import Backdrop from 'components/Common/Backdrop/Backdrop';
import Layout from 'components/Layout/Layout';
import NoResults from 'components/SearchPage/NoResults/NoResults';
import SearchFilters from 'components/SearchPage/SearchFilters/SearchFilters';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'store';
import isDesktop from 'store/app/selector/isDesktop';
import fetchFavouritesOperation from 'store/favourite/operation/fetchFavouritesOperation';
import getLandingPageData from 'store/landing/selector/getLandingPageData';
import fetchSearchResultsAndPricesOperation from 'store/search/operation/fetchSearchResultsAndPricesOperation';
import setParamsFromQueryStringOperation from 'store/search/operation/setParamsFromQueryStringOperation';
import getCurrentResults from 'store/search/selector/getCurrentResults';
import getIsShowSearchFilters from 'store/search/selector/getIsShowSearchFilters';
import isSearchLoading from 'store/search/selector/isSearchLoading';
import getStudioTotalResultsAvailable from 'store/studioSearch/selector/getStudioTotalResultsAvailable';
import ItemsList from 'components/SearchPage/ItemsList/ItemsList';
import SSRParams from 'utils/class/SSRParams';
import ItemsLoadingSpinner from 'components/SearchPage/ItemsList/ItemsLoadingSpinner/ItemsLoadingSpinner';
import { startSearchSessionAction } from 'store/search/slice';
import RetryFetchSearchResultsModal from 'components/CategorySearchPage/RetryFetchSearchResultsModal/RetryFetchSearchResultsModal';
import styles from './SearchPage.module.scss';

const SearchPage = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const isDesktopDevice = useSelector(isDesktop);
  const fallbackLpData = useSelector(getLandingPageData);
  const results = useSelector(getCurrentResults);
  const totalImages = useSelector(getStudioTotalResultsAvailable);
  const isShowFilters = useSelector(getIsShowSearchFilters);
  const isSearchPageLoading = useSelector(isSearchLoading);
  const showNoResults = !isSearchPageLoading && fallbackLpData && results.products.length === 0 && totalImages === 0;
  const showFilters = isShowFilters && isDesktopDevice;
  const isLoadingWithoutProducts = isSearchPageLoading && results.products.length === 0 && totalImages === 0;

  useEffect(() => {
    dispatch(fetchFavouritesOperation());
    dispatch(startSearchSessionAction());
  }, []);

  useEffect(() => {
    dispatch(setParamsFromQueryStringOperation(new URLSearchParams(location.search)));

    dispatch(fetchSearchResultsAndPricesOperation());
  }, [location]);

  return (
    <Layout>
      <div className={styles.searchPageContent}>
        <RetryFetchSearchResultsModal />
        {showNoResults ? (
          <NoResults />
        ) : (
          <>
            {showFilters && <SearchFilters />}
            <article className={styles.article}>
              <ItemsList />
            </article>
          </>
        )}
      </div>
      {isLoadingWithoutProducts && (
        <div className={styles.loaderContainer}>
          <ItemsLoadingSpinner />
        </div>
      )}
      <Backdrop />
    </Layout>
  );
};

export default SearchPage;

export const fetchSearchPageInitialData = (params: SSRParams): Promise<any>[] => {
  // * Disabled in scope of OP-37056 to avoid server<>server communication without cookies
  // const safeQueryString = sanitiseXSS(params.req.query);
  // params.dispatch(setParamsFromQueryStringServerOperation(safeQueryString));
  // return [params.dispatch(fetchSearchResultsOperation())];
  return [];
};
